/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, borders, functions } = theme;
  const { active, darkMode } = ownerState;
  const { green, white, black, grey, dark, light, background } = palette;
  const { borderRadius } = borders;
  const { pxToRem, rgba, linearGradient } = functions;

  return {
    background: active ? linearGradient(green.main, green.state) : rgba(background.sidenav, 1),
    borderBottom: active ? 0 : 4,
    borderRight: active ? 0 : 1,
    borderLeft: active ? 0 : 1,
    borderTop: active ? 0 : 1,
    borderColor: active ? "none" : grey[600],
    color: darkMode ? light.main : dark.main,
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: `${pxToRem(6)} ${pxToRem(10)}`,
    margin: `${pxToRem(6)}`,
    borderRadius: borderRadius.md,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: "none",
    [breakpoints.up("xl")]: {
      transition: transitions.create(["box-shadow", "background-color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    "&:hover, &:focus": {
      borderBottom: active ? 0 : 2,
      borderRight: active ? 0 : 2,
      borderLeft: active ? 0 : 2,
      borderTop: active ? 0 : 2,
      backgroundColor: () => {
        let backgroundValue;
        if (!active) {
          backgroundValue = darkMode ? rgba(white.main, 0.2) : rgba(black.main, 0.2);
        }
        return backgroundValue;
      },
      borderColor: () => {
        let borderColorValue;
        if (!active) {
          borderColorValue = darkMode ? black.main : white.main;
        }
        return borderColorValue;
      },
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const { palette, transitions, borders, functions } = theme;
  const { darkMode, active } = ownerState;
  const { white, black } = palette;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    minWidth: pxToRem(24),
    minHeight: pxToRem(16),
    color: darkMode && !active ? black.main : white.main,
    borderWidth: 5,
    borderRadius: borderRadius.sm,
    display: "grid",
    placeItems: "center",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& svg, svg g": {
      color: darkMode ? white.main : black.main,
    },
  };
}

const collapseIcon = ({ palette: { white, black } }, { active }) => ({
  color: active ? white.main : black.main,
});

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { collapseSidenav, active } = ownerState;
  const { size, fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(10),

    [breakpoints.up("xl")]: {
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
      opacity: collapseSidenav ? 0 : 1,
      maxWidth: collapseSidenav ? 0 : "100%",
      marginLeft: collapseSidenav ? 0 : pxToRem(10),
    },

    "& span": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: size.xs,
      lineHeight: 0,
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
